export const gitCommit = '64749fcf'
